
export default {
	state: {
		currentView: 'map'
	},

	mutations: {
		setCurrentView (state, payload) {
			state.currentView = payload !== undefined ? payload : "map";
		}
	}
};
